import React, { useEffect, useState } from 'react';
import ICAL from 'ical.js';
import Skeleton from 'react-loading-skeleton';
import { Card, CardBody, CardTitle, Table } from 'reactstrap';
import { FormatCET } from 'utils';
import { useTranslation } from 'react-i18next';

const CalendarEvent = ({ icsData }) => {
  const { t } = useTranslation();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    // Parse the ICS data
    try {
        if (!icsData || !icsData.includes("BEGIN:VCALENDAR")) {
            console.error("Invalid ICS data:", icsData);
            return;
        }

        // 1. Remove any HTML content (which starts with "<html" or "<body")
        let cleanIcsData = icsData.split("\n").filter(line => !line.startsWith("<")).join("\n");

        // 2. Remove invalid trailing content after END:VEVENT or END:VCALENDAR
        cleanIcsData = cleanIcsData.replace(/END:VEVENT[\s\S]*?END:VCALENDAR/, "END:VEVENT\nEND:VCALENDAR");

        console.log("Sanitized ICS Data:", cleanIcsData);

        const jcalData = ICAL.parse(cleanIcsData);
        const vcalendar = new ICAL.Component(jcalData);
        const vevent = vcalendar.getFirstSubcomponent('vevent');

        if (!vevent) {
            console.error("No VEVENT component found in the ICS data");
            return;
        }

        // Extract event details
        const eventDetails = {
            summary: vevent.getFirstPropertyValue('summary'),
            description: vevent.getFirstPropertyValue('description'),
            location: vevent.getFirstPropertyValue('location') || t('email.event.NoLocation'),
            start: FormatCET(vevent.getFirstPropertyValue('dtstart')),
            end: FormatCET(vevent.getFirstPropertyValue('dtend')),
            organizer: vevent.getFirstPropertyValue('organizer').replace(/mailto:/i, ''),
            attendee: vevent.getFirstPropertyValue('attendee') ? vevent.getFirstPropertyValue('attendee').replace(/mailto:/i, '') : t('email.event.NoAttendee')
        };

        setEvent(eventDetails);
    } catch (error) {
        console.error("Error parsing ICS data:", error);
    }
  }, [icsData, t]);

  if (!event) {
    return <Skeleton height={30} count={6} />;
  }

  const eventDetailsRows = [
    { label: 'email.event.Organizer', value: event.organizer },
    { label: 'email.event.Starts', value: event.start },
    { label: 'email.event.Ends', value: event.end },
    { label: 'email.event.Location', value: event.location },
    { label: 'email.event.Attendee', value: event.attendee },
  ];

  return (
    <Card>
      <CardBody>
        <CardTitle tag="h5">{event.summary}</CardTitle>
        <Table>
          <tbody>
            {eventDetailsRows.map((row, index) => (
              <tr key={index}>
                <th scope="row">{t(row.label)}</th>
                <td>{row.value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default CalendarEvent;
